import { CookieKeys } from '@finn/ui-utils';
import Cookies from 'js-cookie';
import { useRouter } from 'next/compat/router';
import { useEffect, useState } from 'react';

const useRibbonHidden = () => {
  const [ribbonHidden, setRibbonHidden] = useState(false);

  const router = useRouter();
  const pathname = router?.asPath;

  useEffect(() => {
    // pre-dismiss the ribbon for people visiting partnerships and club pages for 30 days
    if (pathname?.includes('/partnerships/') || pathname?.includes('/club')) {
      setTimeout(() => {
        setRibbonHidden(true);
      }, 300);
      Cookies.set(CookieKeys.RIBBON_DISMISSED, 'true', { expires: 30 });

      return;
    }

    const isHidden = !!Cookies.get(CookieKeys.RIBBON_DISMISSED);
    setTimeout(() => {
      setRibbonHidden(!!isHidden);
    }, 300);
  }, [pathname]);

  return ribbonHidden;
};

export default useRibbonHidden;
